<template>
  <div class="table">
    <div class="container">
      <div class="handle-box">
        <el-form :model="queryCondition" ref="queryCondition" :label-position="labelPosition" label-width="120px" class="searchForm">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="年份" prop="yearList">
                <el-select v-model="queryCondition.yearList" multiple placeholder="请选择" style="width:100%">
                  <el-option v-for="item in yearListOptions" :label="item" :value="item"></el-option>
                </el-select>
                <!-- <el-date-picker v-model="queryCondition.yearList" value-format="yyyy" format="yyyy" type="year" placeholder="选择年" style="width:100%"></el-date-picker> -->
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="季度" prop="quarter">
                <el-select v-model="queryCondition.quarter" placeholder="请选择" style="width:100%">
                  <el-option :key="index" v-for="(item,index) in quarterOptions" :label="item.label" :value="item.key"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex" justify="center" align="middle">
            <el-button size="mini" @click="onSearch" type="primary">查询</el-button>
            <el-button size="mini" @click="onReset" type="primary">重置</el-button>
          </el-row>
        </el-form>
      </div>
      <el-row class="action-btn-row">
        <el-button size="mini" class="btn" type="primary" @click="onExport">导出</el-button>
      </el-row>
      <el-tabs type="border-card" @tab-click="handleClick" v-model="activeName">
        <el-tab-pane label="QSPI" name="QSPI">
          <el-table ref="plxTable" :data="tableData" max-height="500" border highlight-current-row>
            <el-table-column show-overflow-tooltip align="center" label="评价期" prop="scoreDate" min-width="100"></el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="Excellent performance" prop="excellentPerformance" min-width="100">
              <template slot-scope="scope">
                <span>{{Math.round(parseFloat((scope.row.excellentPerformance * 100).toPrecision(12)))}}%</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="Good performance" prop="goodPerformance" min-width="100">
              <template slot-scope="scope">
                <span>{{Math.round(parseFloat((scope.row.goodPerformance * 100).toPrecision(12)))}}%</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="Baseline" prop="baseline" min-width="120">
              <template slot-scope="scope">
                <span>{{Math.round(parseFloat((scope.row.baseline * 100).toPrecision(12)))}}%</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="Needs Improvement" prop="needsImprovement" min-width="120">
              <template slot-scope="scope">
                <span>{{Math.round(parseFloat((scope.row.needsImprovement * 100).toPrecision(12)))}}%</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="A+B" prop="aandBScore" min-width="90">
              <template slot-scope="scope">
                <span>{{Math.round(parseFloat((scope.row.aandBScore * 100).toPrecision(12)))}}%</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="Total" prop="total" min-width="120">
              <template slot-scope="scope">
                <span>{{Math.round(parseFloat((scope.row.total * 100).toPrecision(12)))}}%</span>
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination">
            <el-pagination @size-change="handleSizeChange1" @current-change="handleCurrentChange1" :current-page="pageNum1" :page-sizes="pageSizeList" :page-size="pageSize1" :layout="pageLayout" :total="totalCount1" :page-count="pages1">
            </el-pagination>
          </div>
        </el-tab-pane>
        <el-tab-pane label="FSQPI" name="FSQPI">
          <el-table ref="plxTable" :data="tableData" max-height="500" border highlight-current-row>
            <el-table-column show-overflow-tooltip align="center" label="评价期" prop="scoreDate" min-width="100"></el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="Excellent performance" prop="excellentPerformance" min-width="100">
              <template slot-scope="scope">
                <span>{{Math.round(parseFloat((scope.row.excellentPerformance * 100).toPrecision(12)))}}%</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="Good performance" prop="goodPerformance" min-width="100">
              <template slot-scope="scope">
                <span>{{Math.round(parseFloat((scope.row.goodPerformance * 100).toPrecision(12)))}}%</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="Baseline" prop="baseline" min-width="120">
              <template slot-scope="scope">
                <span>{{Math.round(parseFloat((scope.row.baseline * 100).toPrecision(12)))}}%</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="Needs Improvement" prop="needsImprovement" min-width="120">
              <template slot-scope="scope">
                <span>{{Math.round(parseFloat((scope.row.needsImprovement * 100).toPrecision(12)))}}%</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="A+B" prop="aandBScore" min-width="90">
              <template slot-scope="scope">
                <span>{{Math.round(parseFloat((scope.row.aandBScore * 100).toPrecision(12)))}}%</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip align="center" label="Total" prop="total" min-width="120">
              <template slot-scope="scope">
                <span>{{Math.round(parseFloat((scope.row.total * 100).toPrecision(12)))}}%</span>
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination">
            <el-pagination @size-change="handleSizeChange2" @current-change="handleCurrentChange2" :current-page="pageNum2" :page-sizes="pageSizeList" :page-size="pageSize2" :layout="pageLayout" :total="totalCount2" :page-count="pages2">
            </el-pagination>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import store from '@/store/index'
import IcSelect from "@/components/common/icSelect";
import qspiReport from "@/api/qspiReport/index";
import paginationMixin from '@/mixins/pagitionMixin';
import commonFunction from "@/utils/dataTableUtils";
import { fileService } from "@/api/common/file-utils";
export default {
  name: 'fspi',
  mixins: [paginationMixin],
  components: {
    IcSelect,
  },
  data() {
    return {
      activeName: "QSPI",
      totalCount1: 0,
      pages1: 1,
      pageNum1: 1,
      pageSize1: 15,
      totalCount2: 0,
      pages2: 1,
      pageNum2: 1,
      pageSize2: 15,
      queryCondition: {
        yearList: [],
        quarter: "",
        performanceType: "QSPI",
        pageSize: 15,
        pageNum: 1,
      },
      tableData: [],
      yearListOptions: [],
      quarterOptions: [
        {
          label: "All",
          key: ''
        },
        {
          label: "Q1",
          key: 'Q1'
        },
        {
          label: "Q2",
          key: "Q2"
        },
        {
          label: "Q3",
          key: "Q3"
        },
        {
          label: "Q4",
          key: "Q4"
        }
      ],
    }
  },
  created() {
    this.queryData()
    this.rebackYearsForSelector()
  },
  methods: {
    queryData() {
      if (this.activeName == 'QSPI') {
        this.queryCondition.pageSize = this.pageSize1
        this.queryCondition.pageNum = this.pageNum1
      } else {
        this.queryCondition.pageSize = this.pageSize2
        this.queryCondition.pageNum = this.pageNum2
      }
      qspiReport.queryPage(this.queryCondition).then(res => {
        this.tableData = res.resultData;
        if (this.activeName == 'QSPI') {
          this.totalCount1 = res.totalCount;
        } else {
          this.totalCount2 = res.totalCount;
        }
      });
    },
    rebackYearsForSelector() {
      qspiReport.rebackYearsForSelector().then(res => {
        console.log('444', res);
        this.yearListOptions = res.data
      });
    },
    handleClick(tab, event) {
      if (tab.name == 'QSPI') {
        this.queryCondition.performanceType = 'QSPI'
      } else {
        this.queryCondition.performanceType = 'FSQPI'
      }
      this.queryData()
    },
    onSearch() {
      this.queryCondition.pageNum = 1
      this.queryCondition.pageSize = 15
      this.queryData()
    },
    onReset() {
      this.$refs['queryCondition'].resetFields()
      this.queryCondition = {
        yearList: [],
        quarter: "",
        performanceType: "QSPI",
        pageSize: 15,
        pageNum: 1,
      }
      if (this.activeName == 'QSPI') {
        this.queryCondition.performanceType = 'QSPI'
      } else {
        this.queryCondition.performanceType = 'FSQPI'
      }
      this.queryData();
    },
    handleSizeChange1(val) {
      this.pageSize1 = val
      this.queryData()
    },
    handleCurrentChange1(val) {
      this.pageNum1 = val
      this.queryData()
    },
    handleSizeChange2(val) {
      this.pageSize2 = val
      this.queryData()
    },
    handleCurrentChange2(val) {
      this.pageNum2 = val
      this.queryData()
    },
    onExport() {
      // qspiReport.exportOverallPerformance(this.queryCondition).then(res => {
      //   fileService.respToFile(res, 'QSPI_Overall Performance报表.xlsx');
      // });
      console.log('this.queryCondition.performanceType', this.queryCondition.performanceType);
      if (this.queryCondition.performanceType === 'QSPI') {
        qspiReport.exportOverallPerformance(this.queryCondition).then(res => {
          fileService.respToFile(res, 'QSPI_Overall Performance报表.xlsx');
        });
      } else if (this.queryCondition.performanceType === 'FSQPI') {
        qspiReport.exportOverallPerformance(this.queryCondition).then(res => {
          fileService.respToFile(res, 'FSQPI_Overall Performance报表.xlsx');
        });
      }
    },
  },
  extends: commonFunction
}
</script>
<style scoped >
</style>
